import clsx from 'clsx';
import React from 'react';
import { formatNumeric } from 'utils';
import { observer } from 'mobx-react';
import useStyles from '../ImagesTab.styles';
import { ImagePreview } from './ImagePreview';
import Typography from '@material-ui/core/Typography';
import { CreativeImage } from '../../../../../types';
import { useImagePreview } from '../hooks/useImagePreview';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import { Card, CardActions, Checkbox, CardMedia, Button } from '@material-ui/core';

interface Props {
  images: CreativeImage[];
  isSelected: (image: CreativeImage) => boolean;
  handleImageSelect: (image: CreativeImage, checked: boolean) => void;
}

export const ImagesGallery: React.FC<Props> = observer(({ images = [], isSelected, handleImageSelect }: Props) => {
  const classes = useStyles();
  const { handleCloseImagePreview, openImagePreview, handleOpenImagePreview } = useImagePreview();

  return (
    <div className={classes.ImagesGalleryRoot}>
      {images.length ? (
        images.map((image, index) => (
          <LazyLoadComponent key={index}>
            <Card className={clsx(classes.ImageCard, isSelected(image) ? classes.ImageCardSelected : null)}>
              <CardActions>
                <Checkbox
                  size="small"
                  color="primary"
                  value={image.id}
                  name={`image-${image.id}`}
                  checked={isSelected(image)}
                  onChange={(_, checked: boolean) => handleImageSelect(image, checked)}
                />
                <span className="text-sm text-red-600 font-bold" color="red">
                  {image.imageType === 'ai_image' ? 'AI' : ''}
                </span>
                <Button
                  size="small"
                  color="primary"
                  style={{ marginLeft: 'auto' }}
                  onClick={() => handleOpenImagePreview(image.url)}
                >
                  preview
                </Button>
              </CardActions>
              <div className="flex justify-between mx-1">
                <span className="text-sm">CTR: {image.ctr ? formatNumeric(image.ctr, 'ctr') : 'N/A'}</span>
                <span className="text-sm">SPENT: {image.spent ? formatNumeric(image.spent, 'cost') : 'N/A'}</span>
              </div>
              <CardMedia
                component="img"
                image={image.url ?? ''}
                alt="keywee-creative-image"
                onClick={() => handleImageSelect(image, !isSelected(image))}
              />
            </Card>
          </LazyLoadComponent>
        ))
      ) : (
        <Typography>No images to show !</Typography>
      )}

      {openImagePreview && (
        <ImagePreview open={openImagePreview.show} url={openImagePreview.url} onClose={handleCloseImagePreview} />
      )}
    </div>
  );
});
